import request from "@/utils/request";
import { encryptor } from "./encryptor.js";
import { getToken } from "@/utils";
import router from "../router";
import { Message } from "element-ui";

export function post(method = "", params) {
  let token = getToken();
  if (!token) return router.push("/login");
  return new Promise(resolve => {
    const secureRequest = encryptor.generateSecureRequest("api." + method, params);
    return request({
      method: "post",
      data: secureRequest,
    })
      .then(res => {
        if (res.statusCode >= 500) return resolve(null);
        let _res = encryptor.decryptAES(res.data);
        if (_res.state === -99) {
          Message.error(_res.msg);
          router.push("/login");
          this.$store.dispatch("user/logout");
          return resolve(null);
        }
        resolve(_res);
      })
      .catch(err => {
        resolve(null);
      });
  });
}
